module.exports = __webpack_public_path__ + "static/massingEnd-bde2861189b87310bddaec860629986a.png";